/* eslint-disable react/prop-types */
import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {useMount} from '@s-ui/react-hooks'
import {useRouter} from '@s-ui/react-router'
import {useDelayToNextFrame} from '@adv-mt/mt-hook-use-delay-to-next-frame'

import {getInitialProps} from './getInitialProps.js'

const TransactionBuyerPaymentStatusRedirect = ({pathname, newState}) => {
  const {push} = useRouter()

  const delayToNextFrame = useDelayToNextFrame()

  useMount(() => {
    delayToNextFrame(() => {
      push({pathname, state: newState})
    })
  })

  return <></>
}

TransactionBuyerPaymentStatusRedirect.displayName = 'TransactionBuyerPaymentStatusRedirect'

TransactionBuyerPaymentStatusRedirect.getInitialProps = getInitialProps

export default TransactionBuyerPaymentStatusRedirect
